var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("highlights")))]),
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.settings.SaleEditHighlightSettings,
                    "disable-x": "",
                    "keep-in-y": "",
                    tag: "w-list",
                    "target-class": "handle",
                  },
                },
                [
                  _vm._l(
                    _vm.settings.SaleEditHighlightSettings,
                    function (highlight, i) {
                      return _c(
                        "w-list-item",
                        {
                          key: highlight.uid,
                          style: highlight.Style.getStyle(),
                          attrs: { "show-handle": "" },
                        },
                        [
                          _c("w-list-item-text", [
                            _vm._v(_vm._s(highlight.toString())),
                          ]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("edit-highlight"),
                                      expression: "$ct('edit-highlight')",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEditCondition(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "pen" } })],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("remove-highlight"),
                                      expression: "$ct('remove-highlight')",
                                    },
                                  ],
                                  staticClass: "danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeHighlight(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "trash" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addClicked()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("add-highlight"))),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditHighlight != null } },
        [
          _vm.toEditHighlight
            ? _c("app-highlight-edit", {
                attrs: { value: _vm.toEditHighlight },
                on: {
                  input: function ($event) {
                    return _vm.onHighlightInput($event)
                  },
                  close: function ($event) {
                    _vm.toEditHighlight = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }